import { render } from "./qr-payment.vue?vue&type=template&id=4bbb271a&scoped=true"
import script from "./qr-payment.vue?vue&type=script&lang=js"
export * from "./qr-payment.vue?vue&type=script&lang=js"

import "./qr-payment.vue?vue&type=style&index=0&id=4bbb271a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bbb271a"]])

export default __exports__